import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function AuthModal({
  isOpen,
  view = "login",
  onClose,
  onChangeView,
  defaultEmail,
}) {
  const { login, signup, resetPassword } = useAuth();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    email: "",
    password: "",
    firstName: "",
    lastName: "",
    phone: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  // When opening the modal, optionally seed the email field from defaultEmail
  useEffect(() => {
    if (isOpen && defaultEmail) {
      setForm((f) => ({ ...f, email: defaultEmail }));
    }
  }, [isOpen, defaultEmail]);

  const onChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleLogin = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      await login(form.email, form.password);
      onClose && onClose();
      navigate("/");
    } catch (err) {
      setError(err?.message || "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");

    // Validate all required fields
    if (!form.firstName.trim()) {
      setError("First name is required");
      setSubmitting(false);
      return;
    }
    if (!form.lastName.trim()) {
      setError("Last name is required");
      setSubmitting(false);
      return;
    }
    if (!form.email.trim()) {
      setError("Email is required");
      setSubmitting(false);
      return;
    }
    if (!form.password.trim()) {
      setError("Password is required");
      setSubmitting(false);
      return;
    }
    if (!form.phone.trim()) {
      setError("Phone is required");
      setSubmitting(false);
      return;
    }

    try {
      const name = [form.firstName, form.lastName].filter(Boolean).join(" ");
      await signup(form.email, form.password, name, form.phone);
      // After signup, auto-login
      await login(form.email, form.password);
      onClose && onClose();
      navigate("/");
    } catch (err) {
      setError(err?.message || "Signup failed");
    } finally {
      setSubmitting(false);
    }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      await resetPassword(form.email);
      onChangeView && onChangeView("login");
    } catch (err) {
      setError(err?.message || "Reset password failed");
    } finally {
      setSubmitting(false);
    }
  };
  if (!isOpen) return null;

  const handleBackdrop = (e) => {
    if (e.target === e.currentTarget && typeof onClose === "function")
      onClose();
  };

  return (
    <div
      className="modal modalCentered form-sign-in modal-part-content show"
      role="dialog"
      aria-modal="true"
      onClick={handleBackdrop}
      style={{ display: "block" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          {view === "login" && (
            <div>
              <div className="header">
                <div className="demo-title">Log in</div>
                <span
                  className="icon-close icon-close-popup"
                  role="button"
                  tabIndex={0}
                  aria-label="Close"
                  onClick={onClose}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ")
                      onClose && onClose();
                  }}
                ></span>
              </div>
              <div className="tf-login-form">
                <form onSubmit={handleLogin} acceptCharset="utf-8">
                  <div className="tf-field style-1">
                    <input
                      className="tf-field-input tf-input"
                      placeholder=" "
                      type="email"
                      name="email"
                      value={form.email}
                      onChange={onChange}
                    />
                    <label className="tf-field-label">Email *</label>
                  </div>
                  <div className="tf-field style-1">
                    <input
                      className="tf-field-input tf-input"
                      placeholder=" "
                      type="password"
                      name="password"
                      value={form.password}
                      onChange={onChange}
                    />
                    <label className="tf-field-label">Password *</label>
                  </div>
                  {error && <div className="text-danger mb-2">{error}</div>}
                  <div>
                    <a
                      href="#forgotPassword"
                      className="btn-link link"
                      onClick={(e) => {
                        e.preventDefault();
                        onChangeView && onChangeView("forgot");
                      }}
                    >
                      Forgot your password?
                    </a>
                  </div>
                  <div className="bottom">
                    <div className="w-100">
                      <button
                        type="submit"
                        className="tf-btn btn-fill animate-hover-btn radius-3 w-100 justify-content-center"
                        disabled={submitting}
                      >
                        <span>{submitting ? "Logging in..." : "Log in"}</span>
                      </button>
                    </div>
                    <div className="w-100">
                      <a
                        href="#register"
                        className="btn-link fw-6 w-100 link"
                        onClick={(e) => {
                          e.preventDefault();
                          onChangeView && onChangeView("register");
                        }}
                      >
                        New customer? Create your account
                        <i className="icon icon-arrow1-top-left"></i>
                      </a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          )}

          {view === "forgot" && (
            <div>
              <div className="header">
                <div className="demo-title">Reset your password</div>
                <span
                  className="icon-close icon-close-popup"
                  role="button"
                  tabIndex={0}
                  aria-label="Close"
                  onClick={onClose}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ")
                      onClose && onClose();
                  }}
                ></span>
              </div>
              <div className="tf-login-form">
                <form onSubmit={handleReset}>
                  <div>
                    <p>
                      Sign up for early Sale access plus tailored new arrivals,
                      trends and promotions. To opt out, click unsubscribe in
                      our emails
                    </p>
                  </div>
                  <div className="tf-field style-1">
                    <input
                      className="tf-field-input tf-input"
                      placeholder=" "
                      type="email"
                      name="email"
                      value={form.email}
                      onChange={onChange}
                    />
                    <label className="tf-field-label">Email *</label>
                  </div>
                  {error && <div className="text-danger mb-2">{error}</div>}
                  <div>
                    <a
                      href="#login"
                      className="btn-link link"
                      onClick={(e) => {
                        e.preventDefault();
                        onChangeView && onChangeView("login");
                      }}
                    >
                      Cancel
                    </a>
                  </div>
                  <div className="bottom">
                    <div className="w-100">
                      <button
                        type="submit"
                        className="tf-btn btn-fill animate-hover-btn radius-3 w-100 justify-content-center"
                        disabled={submitting}
                      >
                        <span>
                          {submitting ? "Sending..." : "Reset password"}
                        </span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          )}

          {view === "register" && (
            <div>
              <div className="header">
                <div className="demo-title">Register</div>
                <span
                  className="icon-close icon-close-popup"
                  role="button"
                  tabIndex={0}
                  aria-label="Close"
                  onClick={onClose}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ")
                      onClose && onClose();
                  }}
                ></span>
              </div>
              <div className="tf-login-form">
                <form onSubmit={handleSignup}>
                  <div className="tf-field style-1">
                    <input
                      className="tf-field-input tf-input"
                      placeholder=" "
                      type="text"
                      name="firstName"
                      value={form.firstName}
                      onChange={onChange}
                      required
                    />
                    <label className="tf-field-label">First name *</label>
                  </div>
                  <div className="tf-field style-1">
                    <input
                      className="tf-field-input tf-input"
                      placeholder=" "
                      type="text"
                      name="lastName"
                      value={form.lastName}
                      onChange={onChange}
                      required
                    />
                    <label className="tf-field-label">Last name *</label>
                  </div>
                  <div className="tf-field style-1">
                    <input
                      className="tf-field-input tf-input"
                      placeholder=" "
                      type="email"
                      name="email"
                      value={form.email}
                      onChange={onChange}
                      required
                    />
                    <label className="tf-field-label">Email *</label>
                  </div>
                  <div className="tf-field style-1">
                    <input
                      className="tf-field-input tf-input"
                      placeholder=" "
                      type="password"
                      name="password"
                      value={form.password}
                      onChange={onChange}
                      required
                    />
                    <label className="tf-field-label">Password *</label>
                  </div>
                  <div className="tf-field style-1">
                    <input
                      className="tf-field-input tf-input"
                      placeholder=" "
                      type="tel"
                      name="phone"
                      value={form.phone}
                      onChange={onChange}
                      required
                    />
                    <label className="tf-field-label">Phone *</label>
                  </div>
                  {error && <div className="text-danger mb-2">{error}</div>}
                  <div className="bottom">
                    <div className="w-100">
                      <button
                        type="submit"
                        className="tf-btn btn-fill animate-hover-btn radius-3 w-100 justify-content-center"
                        disabled={submitting}
                      >
                        <span>{submitting ? "Creating..." : "Register"}</span>
                      </button>
                    </div>
                    <div className="w-100">
                      <a
                        href="#login"
                        className="btn-link fw-6 w-100 link"
                        onClick={(e) => {
                          e.preventDefault();
                          onChangeView && onChangeView("login");
                        }}
                      >
                        Already have an account? Log in here
                        <i className="icon icon-arrow1-top-left"></i>
                      </a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AuthModal;
